// Shared ui elements for Promo popup
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Articles } from "support/beacon";
import { Nl, Tip } from "view/tooltips";
export const Tick = () => (React.createElement("i", { className: "fa fa-check" }));
export const Info = (props) => (React.createElement(Tip, { content: props.hint },
    React.createElement("i", { className: "info_chip fa fa-info-circle ml-1" })));
export const InfoLink = (props) => (React.createElement("a", { href: props.link, target: "_blank" },
    React.createElement(Info, { hint: props.hint })));
export const BeaconLink = (props) => (React.createElement(Tip, { content: props.hint },
    React.createElement("a", { className: "info_chip fa fa-info-circle ml-1", "data-beacon-article-sidebar": props.article })));
export const ChemTextHint = () => {
    const { t } = useTranslation();
    return React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t("info.chem_text_hint_nl")), article: Articles.CHEMTEXT });
};
export const LicenseHint = () => {
    const { t } = useTranslation();
    return React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t("info.license_hint_nl")), article: Articles.LICENSE });
};
export const PermissionHint = () => {
    const { t } = useTranslation();
    return React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t("info.commercial_use_hint_nl")), article: Articles.LICENSE });
};
